/**
 * buildSequence(start, step, levels) → number[]
 * Erzeugt aufsteigende + absteigende Sequenz.
 * Länge = 2 * levels + 1. Peak an Index `levels`.
 * Beispiel: (15, 15, 3) → [15, 30, 45, 60, 45, 30, 15]
 */
export function buildSequence(start, step, levels) {
  const seq = [];
  for (let i = 0; i <= levels; i++) seq.push(start + i * step);
  for (let i = levels - 1; i >= 0; i--) seq.push(start + i * step);
  return seq;
}

/**
 * buildPhases(seq, restSecs) → { type, dur, stepIdx }[]
 * Wechselt Work/Rest; kein Rest nach dem letzten Work-Schritt.
 */
export function buildPhases(seq, restSecs) {
  return seq.flatMap((dur, i) => {
    const work = { type: 'work', dur, stepIdx: i };
    if (i < seq.length - 1) {
      return [work, { type: 'rest', dur: restSecs, stepIdx: i }];
    }
    return [work];
  });
}

/**
 * calcTotalSeconds(seq, restSecs) → number
 * Summe aller Work-Dauern + (seq.length - 1) × restSecs
 */
export function calcTotalSeconds(seq, restSecs) {
  return seq.reduce((a, b) => a + b, 0) + (seq.length - 1) * restSecs;
}

/**
 * formatTime(seconds) → "MM:SS"
 */
export function formatTime(seconds) {
  const s = Math.max(0, seconds);
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}
